module.exports = __webpack_public_path__ + "static/media/pst-square.da8c7476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/pst-square.svg
// module id = 532
// module chunks = 0